module.exports = __webpack_public_path__ + "img/streamline-icon-store-front@450x450.d22e5b93.svg";